import {find} from 'lodash'
import UsersListApi from '@/api/Users/api'

export default {
  computed: {
    usersListProjects: {
      get () {
        return this.$store.getters.usersListProjects
      }
    }
  },
  methods: {
    async getKPIHelpers (resultUserHelpers) {
      const promises = resultUserHelpers.map(async item => {
        item.user = await this.getUser(item.user)
        return item
      })
      const result = await Promise.all(promises)
      return result
    },
    async getUser (id) {
      if (!id) return ''
      const user = find(this.usersListProjects, {_id: id})
      if (user) return user
      try {
        const { data } = await UsersListApi.getUser(id)
        return data
      } catch (e) {
        console.error(e)
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getKPIHelpers.js